module.exports = {
  // baseUrl:后台请求地址 -- 测试 - mapnew5sit、模拟生产 - mapnew5uat、生产 - mapmpm5
  // weixin:微信中控平台请求地址 -- 测试 - weixincs、模拟生产 - weixincs、生产 - weixin
  
  // sit
  // baseUrl: 'https://mapnew5sit.midea.com',
  // weixinUrl: 'https://weixincs.midea.com',
  // weixinPath: '/wcp/sic/api/WCP_MP_MAKE_SIGNATURE/2482b2043fb345e98343998c2eea1085/949c6fe9-8a43-48fc-8662-b838b22c48ba',

  // prod
  baseUrl: 'https://mapmpm5.midea.com',
  weixinUrl: 'https://weixin.midea.com',
  weixinPath: '/alicloud/wcp/sic/api/WCP_MP_MAKE_SIGNATURE/7a43e7a4b24747b8be66ac579922b67f/a7927b30-a49c-4d1e-9604-dfef53de7fbf'
 
  // 微信配置文件
  // 测试 MP_verify_iKVJwPiFTqLhMGsu.txt
  // 生产 MP_verify_MY6pQhfTt3ve7LWa.txt
}
